<template>
	<v-container>
		<Snackbar v-if="errored" msg="Error from Server" />
		<Snackbar v-if="deleted" msg="Operation Successfull" />		
		<v-dialog v-model="create" width="75%">
			<v-card>
				<NewResource ref="createDialog"/>
			</v-card>
		</v-dialog>
		<v-dialog v-model="edit" width="75%">
			<v-card>
				<EditResource :editId="editId" ref="editDialog"/>
			</v-card>
		</v-dialog>	
		<v-card-title>
			Resources
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
			<v-btn
				color="success"
				class="ml-8"
				@click="create = !create"
			>
				New
				<v-icon class="ms-2">
					mdi-plus
				</v-icon>
			</v-btn>			
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="resources"
			:search="search"
			class="elevation-1"
		>
			<template v-slot:[`item.link`]="{ item }">
				<v-btn
					small
					icon
					color="primary"
					class="ms-2"
					:href="item.url"
				>
					<v-icon>mdi-link</v-icon>
				</v-btn>				
			</template>	
			<template v-slot:[`item.actions`]="{ item }">
				<v-tooltip left>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="primary"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="(editId = item._id) && (edit = !edit)"
						>
							<v-icon>mdi-pencil</v-icon>
						</v-btn>
					</template>
					<span> Edit </span>
				</v-tooltip>                
				<v-tooltip right>
					<template v-slot:activator="{ on, attrs }">                
						<v-btn
							small
							icon
							color="error"
							class="ms-2"
							v-bind="attrs"
							v-on="on"
							@click="confirmDelete() && deleteResource(item)"
						>
							<v-icon>mdi-delete</v-icon>
						</v-btn>
					</template>
					<span> Delete </span>
				</v-tooltip>
			</template>			
		</v-data-table>
	</v-container>
</template>

<script>
import axios from '../../plugins/axios'
import Snackbar from '@/components/Snackbar.vue'
import NewResource from '../Resources/New.vue'
import EditResource from '../Resources/Edit.vue'

export default {
  name: 'Resources',
	components: {
		Snackbar,
		NewResource,
		EditResource
	},	
  data: () => ({
    loading: true,
    errored: false,
    deleted: false,
	create: false,
	edit: false,
	editId: null,
    resources: [],
		search: '',
		expanded: [],
		headers: [
			{ text: 'Title', value: 'title', width: '20%', align: 'start' },
			{ text: 'Description', value: 'description', width: '30%', align: 'start' },
			{ text: 'Projects', value: 'projectId', width: '25%', align: 'start' },
			{ text: 'Link', value: 'link', width: '10%', align: 'start' },
			{ text: 'Actions', value: 'actions', sortable: false, align: 'center', width: '10%' }
		]
  }),
	mounted() {
		this.getResources();
	},
	methods: {
		formateResources(){
			this.resources.forEach(e => {
				e.projectId = e.projectId.name;
			})
		},

		getResources(){
			axios
			.get(`/resource/`)
			.then(res => {
				this.resources = res.data.data;
				this.formateResources();
			})
			.catch(err => {
				console.error("axios err", err);
				this.errored = true;
			})
			.finally(() => this.loading = false);
		},

		confirmDelete(){
			return confirm("Are you sure you want to delete this resource?");
		},

		deleteResource(resource) {
			axios
			.delete(`/resource/`, {data: {_id: resource._id}})
			.then(() => {
        this.deleted = true
				this.getResources();
			})
			.catch(err => {
				console.error("error", err);
				this.errored = true;
			})
			.finally(() => {
				this.loading = false;
			});
		}
	},
	watch: {
		create: function(){
			if(!this.create){
				this.getResources();
				this.$refs.createDialog.reset();
			}
		},

		edit: function(){
			if(!this.edit){
				this.getResources();
				this.editId = null;
				this.$refs.editDialog.reset();
			}
		}
	}
}
</script>

<style>

</style>